<template>
    <div v-if="false === showError">
        <fb-post v-for="post in posts" :data="post" v-bind:key="post.id" :page="pageData" />
    </div>
    <div v-else class="center tac">
        <h2>Der Social Media Feed kann derzeit nicht angezeigt werden.<br />Wir arbeiten an einer Lösung.</h2>
        <p>Bis dahin findet ihr uns natürlich weiterhin direkt bei Instagram und Facebook.</p>

        <div class="m-t-2" style="display: flex; justify-content: center; column-gap: 16px;">
            <a href="https://www.facebook.com/KASSECKER/" target="_blank"><img src="@/assets/images/icons/facebook.svg" alt="" width="40"></a>
            <a href="https://www.instagram.com/kassecker_official" target="_blank"><img src="@/assets/images/icons/instagram.svg" alt="" width="40"></a>
        </div>
    </div>
</template>

<script>
	import Post from './Post';

	export default {
		name: "Facebook",
		data() {
			return {
				// access_token:
				// 	'EAAFAHmVCvcIBAJZCXIfibwEbZA5IL5bUJzWQ15p5ql491Uq6RVA3iHufXUFWZAUeLcd7mV3RvgGgZCypEZAHgz3EyO1Qe8vTg0lVTM1RePqCBTEb1te5GNi2527QIutQOcUrZAwDsHHs06k8HbuZCt8EDuWtyQto3Vh1tYO8r5tLkKTN2NO7wTlKRR8T15ryQqmxhoWM5RZCCgZDZD',
                access_token: 'EAATbMFFlatYBOwhdnWZBcspVe1drpD5voeedYfY8XNtyvdLjpcfE7mLWjOZAvZAtOuHsGoJcQlESTf6rhtmX2m3ZCZCHynik016DWjwandlm4sNNZBXiboifsept0PZAceG5pwIQqOHcWuAzzwNZAyJh6TgLgLTfofmUrBK9S55QaeqohtGKNMOLFHRhDuZA6zHMJ',
				token_type: "bearer",
				posts: [],
				pageData: {},
                loading: true,
                showError: false
			};
		},
		components: {
			'fb-post': Post
		},
		props: [ 'pageid' ],
		methods: {
			fetchPageData: function () {

				let link = '/' + this.pageid;
				FB.api(
					link,
					'GET',
					{
						access_token: this.access_token,
						fields: "id,name,picture,link"
					},
					( response ) => {

                        if( response.hasOwnProperty('error') ) {
                            this.showError = true;
                        }
                        else {
                            this.pageData = response;
                        }
					}
				);

			},
			fetchPosts: function () {

				let link = '/' + this.pageid + '/feed';
				FB.api(
					link,
					'GET',
					{
						access_token: this.access_token,
						fields:
							"id,created_time,message,attachments,full_picture,status_type,embed_html",
                        locale: "de_DE",
                        limit: 50
					},
					( response ) => {
						this.posts = response.data;
                        this.loading = false;
					});
			}
		},
		mounted() {
			fbLoaded.promise.then(() => {
				this.fetchPosts();
				this.fetchPageData();
			});
		},
		created() {

		}
	};
</script>

<style scoped>

.loader{
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: red;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/plugins/Facebook/Facebook.vue